
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  display: block;
  height: 100%;
  place-self: stretch;
  overflow: hidden;
}

  :host section {
  display: flex
}

  :host section {
  flex-direction: column
}

  :host section {
  overflow: hidden
}

  :host section {
  text-align: left
}

.learn-more-link a {
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  color: var(--blue-responsible-darken-2);
}

.learn-more-link a:hover {
  color: var(--blue-responsible-main)
}

.learn-more-link a:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline
}

.learn-more-link a svg {
  padding-left: 2rem
}

.learn-more-link a svg {
  color: var(--blue-responsible-darken-2)
}

.learn-more-link a svg:hover {
  color: var(--blue-responsible-main)
}

.learn-more-link a idb-icon {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem
}

.learn-more-link a idb-icon {
  padding-left: 0.25rem
}

.learn-more-link a idb-icon {
  font-size: var(--fs-base);
  line-height: var(--lh-base)
}

:host a {
  -webkit-text-decoration-line: none;
          text-decoration-line: none
}

.image-type--video-thumbnail idb-icon {
  position: absolute;
  z-index: 50;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
  top:45%;
  left:45%;
  filter:drop-shadow(0 0 0.75rem var(--blue-responsible-lighten-3));
}

.image-type--video-thumbnail idb-icon:hover {
  color: var(--blue-responsible-darken-2)
}

:host([image-rounded='true']) img {
  border-radius: 0.5rem
}

.card {
  height: 100%;
  place-self: stretch;
  align-items: stretch;
  display: flex;
  flex-direction: column
}

@media (min-width: 768px) {

  .card {
    flex-direction: row
  }
}

@media (min-width: 768px) {

  .card.image-position--top {
    flex-direction: column
  }
}

outline-heading, idb-heading {
  margin: 0px;
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
  color: var(--blue-responsible-darken-1);
  -webkit-text-decoration-line: none;
          text-decoration-line: none
}

img {
  height: 270px;
  max-height: 223px;
  width: 100%;
  max-width: 100%;
  border-radius: 0.5rem;
  object-fit: cover
}

.card-image {
  position: relative
}

@media (min-width: 768px) {

  .card-image {
    width: 48%
  }
}

.card-content-wrapper {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 0.25rem
}

@media (min-width: 768px) {

  .card-content-wrapper {
    padding-bottom: 1.25rem
  }

  .card-content-wrapper {
    width: 52%
  }
}

@media (min-width: 768px) {

  .image-position--top .card-image, .image-position--top .card-content-wrapper {
    width: 100%
  }
}

.content-mode--compact .card-content {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem
}

@media (min-width: 768px) {

  .content-mode--compact .card-content {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
  }
}

.content-mode--spacious {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.content-mode--spacious .card-eyebrow, .content-mode--spacious .card-title, .content-mode--spacious .card-content, .content-mode--spacious a.card-title {
  padding-bottom: 0.5rem
}

@media (min-width: 768px) {

  .content-mode--spacious .card-eyebrow, .content-mode--spacious .card-title, .content-mode--spacious .card-content, .content-mode--spacious a.card-title {
    padding-bottom: 1rem
  }
}

@media (min-width: 640px) {

  .content-mode--spacious .card-title {
    padding-bottom: 4rem
  }
}

@media (min-width: 768px) {

  .content-mode--spacious .card-title {
    padding-bottom: 5rem
  }
}

@media (min-width: 1024px) {

  .content-mode--spacious .card-title {
    padding-bottom: 7rem
  }
}

@media (min-width: 640px) {

  .content-mode--spacious .card-summary, .content-mode--spacious .card-content, .content-mode--spacious a.card-summary {
    padding-left: 8rem;
    padding-right: 8rem
  }
}

@media (min-width: 768px) {

  .content-mode--spacious .card-summary, .content-mode--spacious .card-content, .content-mode--spacious a.card-summary {
    padding-left: 10rem;
    padding-right: 10rem
  }
}

@media (min-width: 1024px) {

  .content-mode--spacious .card-summary, .content-mode--spacious .card-content, .content-mode--spacious a.card-summary {
    padding-left: 13rem;
    padding-right: 13rem
  }
}

.card-eyebrow, .card-title, .card-content {
  width: 100%
}

.card-eyebrow {
  margin: 0px;
  display: block;
  padding: 0px
}

.outline-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.outline-rounded-2xl {
  border-radius: 1rem
}

.outline-bg-light-blue {
  background-color: var(--blue-responsible-lighten-5)
}

.outline-bg-blue {
  background-color: var(--blue-responsible-lighten-4)
}

.outline-bg-gray {
  background-color: var(--gray-professional-lighten-4)
}

.outline-bg-green {
  background-color: var(--green-guarantee-lighten-4)
}

.outline-bg-white {
  background-color: var(--neutral-white)
}

.outline-bg-transparent {
  background-color: var(--neutral-transparent)
}

.outline-bg-light-blue, .outline-bg-gray, .outline-bg-green, .outline-bg-blue {
  border-radius: 0.75rem;
}

.outline-bg-light-blue img, .outline-bg-gray img, .outline-bg-green img, .outline-bg-blue img {
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important
}

.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
  padding-left: 1.5rem;
  padding-right: 1.5rem
}

.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
  padding-bottom: 1.5rem
}

.outline-bg-light-blue .card-content-wrapper, .outline-bg-gray .card-content-wrapper, .outline-bg-green .card-content-wrapper, .outline-bg-blue .card-content-wrapper {
  padding-top: 1rem
}
`;